var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _g2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#C4DAF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7202 24.1332H64.82V47.0695L37.6953 60.6318V37.6955L37.795 37.5958L64.7202 24.1332Z",
    fill: "#FDE5B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68945 20.6428L37.695 37.6955V60.6317L3.68945 43.5791V20.6428Z",
    fill: "#FDE5B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3582 19.745L64.7211 24.1328L37.7959 37.5954L51.3582 19.745Z",
    fill: "#FDE5B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.695 58.1387V62.5265L3.68945 45.4739V41.0861L37.695 58.1387Z",
    fill: "#FCD485"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67676 38.5928V26.4266L18.3499 31.2133V43.3795L8.67676 38.5928ZM17.0535 32.2105L9.97314 28.7201V37.5955L17.0535 41.0858V32.2105Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18066 25.629L8.67651 26.4268V38.6927L7.18066 39.7897V25.629Z",
    fill: "#FCD485"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67651 38.6924V38.6924L18.3496 43.4791V45.3738L7.18066 39.7893V39.7893L8.67651 38.6924Z",
    fill: "#FCD485"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97168 37.695L17.052 41.1853V32.31L9.97168 28.72V37.695Z",
    fill: "#C4DAF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67388 28.6207L10.5714 29.0196V37.2966L9.67388 37.895V28.6207Z",
    fill: "#CCCCCC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5704 37.2963V37.2963L17.0524 40.4874V41.5844L9.67285 37.8946V37.8946L10.5704 37.2963Z",
    fill: "#CCCCCC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M64.82 44.5764V49.064L37.6953 62.5266V58.1387L64.82 44.5764Z",
    fill: "#FCD485"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3848 56.2436L49.2629 52.3544V35.202L41.3848 39.0912V56.2436Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 34.4044V52.2548L49.2637 51.5568V35.2022L50.8592 34.4044Z",
    fill: "#CCCCCC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6504 45.2745V33.1083L60.631 29.618V41.7842L53.6504 45.2745ZM55.047 43.0805L59.4348 40.8866V32.0113L55.047 34.2052V43.0805Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.327 28.9197L60.7314 29.7175V41.8837L62.327 42.9806V28.9197Z",
    fill: "#FCD485"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7317 41.8837V41.8837L53.6514 45.374V47.2687L62.3273 42.9806V42.9806L60.7317 41.8837Z",
    fill: "#FCD485"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4357 40.8866L55.0479 43.0805V34.1054L59.4357 32.0112V40.8866Z",
    fill: "#C4DAF1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7335 31.8115L58.836 32.2104V40.4874L59.7335 41.0858V31.8115Z",
    fill: "#C1C1C1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8373 40.4877V40.4877L55.0479 42.3824V43.3796L59.7348 41.086V41.086L58.8373 40.4877Z",
    fill: "#C1C1C1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3828 47.0693C42.3828 47.5679 42.682 47.8671 43.1806 47.6677C43.5795 47.4682 43.9784 46.8699 43.9784 46.3713C43.9784 45.8726 43.6792 45.5735 43.1806 45.7729C42.7817 45.9724 42.3828 46.5707 42.3828 47.0693Z",
    fill: "#999999"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8809 47.2684C42.8809 47.767 43.18 48.0662 43.6786 47.8668C44.0775 47.6673 44.4764 47.069 44.4764 46.5704C44.4764 46.0717 44.1773 45.7726 43.6786 45.972C43.18 46.1715 42.8809 46.7698 42.8809 47.2684Z",
    fill: "#CCCCCC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2324 46.4709V34.4044L33.8058 39.1911V51.2576L24.2324 46.4709ZM32.5094 40.0889L25.5288 36.5986V45.3742L32.5094 48.8645V40.0889Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6367 33.6068L24.2323 34.4046V46.3714L22.6367 47.4683V33.6068Z",
    fill: "#FCD485"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2323 46.3712V46.3712L33.8057 51.1579V53.0527L22.6367 47.5679V47.4682L24.2323 46.3712Z",
    fill: "#FCD485"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5283 45.3741L32.5089 48.8644V40.0888L25.5283 36.5985V45.3741Z",
    fill: "#C4DAF1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2306 36.4987L26.0284 36.8975V45.0748L25.2306 45.6732V36.4987Z",
    fill: "#CCCCCC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0273 45.075V45.075L32.5093 48.2661V49.2633L25.2295 45.6733V45.6733L26.0273 45.075Z",
    fill: "#CCCCCC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3848 55.3461L49.2629 51.6564L50.8584 52.2547L41.3848 56.9417V55.3461Z",
    fill: "#CCCCCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V52.2549L49.2637 51.6565V47.8671L50.8592 48.5651Z",
    fill: "#C7BCB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V52.1552L49.2637 51.5568V47.8671L50.8592 48.5651Z",
    fill: "#C8BDB9",
    fillOpacity: 0.9804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V52.1552L49.2637 51.4571V47.8671L50.8592 48.5651Z",
    fill: "#C9BFBB",
    fillOpacity: 0.9608
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V52.0554L49.2637 51.4571V47.8671L50.8592 48.5651Z",
    fill: "#CAC0BC",
    fillOpacity: 0.9412
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V52.0554L49.2637 51.3574V47.8671L50.8592 48.5651Z",
    fill: "#CBC1BE",
    fillOpacity: 0.9216
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.9557L49.2637 51.3574V47.8671L50.8592 48.5651Z",
    fill: "#CCC3BF",
    fillOpacity: 0.902
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.856L49.2637 51.2576V47.8671L50.8592 48.5651Z",
    fill: "#CEC4C0",
    fillOpacity: 0.8824
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.856L49.2637 51.1579V47.8671L50.8592 48.5651Z",
    fill: "#CFC5C2",
    fillOpacity: 0.8627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.7563L49.2637 51.1579V47.8671L50.8592 48.5651Z",
    fill: "#D0C7C3",
    fillOpacity: 0.8431
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.7563L49.2637 51.0582V47.8671L50.8592 48.5651Z",
    fill: "#D1C8C5",
    fillOpacity: 0.8235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.6565L49.2637 51.0582V47.8671L50.8592 48.5651Z",
    fill: "#D2C9C6",
    fillOpacity: 0.8039
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.5568L49.2637 50.9585V47.8671L50.8592 48.5651Z",
    fill: "#D3CAC7",
    fillOpacity: 0.7843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.5568L49.2637 50.8588V47.8671L50.8592 48.5651Z",
    fill: "#D4CCC9",
    fillOpacity: 0.7647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.4571L49.2637 50.8588V47.8671L50.8592 48.5651Z",
    fill: "#D5CDCA",
    fillOpacity: 0.7451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.4571L49.2637 50.759V47.8671L50.8592 48.5651Z",
    fill: "#D6CECB",
    fillOpacity: 0.7255
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.3574L49.2637 50.6593V47.8671L50.8592 48.5651Z",
    fill: "#D7D0CD",
    fillOpacity: 0.7059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.2576L49.2637 50.6593V47.8671L50.8592 48.5651Z",
    fill: "#D9D1CE",
    fillOpacity: 0.6863
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.2576L49.2637 50.5596V47.8671L50.8592 48.5651Z",
    fill: "#DAD2D0",
    fillOpacity: 0.6667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.1579L49.2637 50.5596V47.8671L50.8592 48.5651Z",
    fill: "#DBD4D1",
    fillOpacity: 0.6471
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.1579L49.2637 50.4599V47.8671L50.8592 48.5651Z",
    fill: "#DCD5D2",
    fillOpacity: 0.6275
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V51.0582L49.2637 50.3601V47.8671L50.8592 48.5651Z",
    fill: "#DDD6D4",
    fillOpacity: 0.6078
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.9585L49.2637 50.3601V47.8671L50.8592 48.5651Z",
    fill: "#DED8D5",
    fillOpacity: 0.5882
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.9585L49.2637 50.2604V47.8671L50.8592 48.5651Z",
    fill: "#DFD9D7",
    fillOpacity: 0.5686
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.8588L49.2637 50.2604V47.8671L50.8592 48.5651Z",
    fill: "#E0DAD8",
    fillOpacity: 0.549
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.8588L49.2637 50.1607V47.8671L50.8592 48.5651Z",
    fill: "#E1DCD9",
    fillOpacity: 0.5294
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.759L49.2637 50.061V47.8671L50.8592 48.5651Z",
    fill: "#E2DDDB",
    fillOpacity: 0.5098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.6593L49.2637 50.061V47.8671L50.8592 48.5651Z",
    fill: "#E4DEDC",
    fillOpacity: 0.4902
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.6593L49.2637 49.9612V47.8671L50.8592 48.5651Z",
    fill: "#E5DFDE",
    fillOpacity: 0.4706
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.5596L49.2637 49.9613V47.8671L50.8592 48.5651Z",
    fill: "#E6E1DF",
    fillOpacity: 0.451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.5596L49.2637 49.8615V47.8671L50.8592 48.5651Z",
    fill: "#E7E2E0",
    fillOpacity: 0.4314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.4599L49.2637 49.7618V47.8671L50.8592 48.5651Z",
    fill: "#E8E3E2",
    fillOpacity: 0.4118
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.4599L49.2637 49.7618V47.8671L50.8592 48.5651Z",
    fill: "#E9E5E3",
    fillOpacity: 0.3922
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.3601L49.2637 49.6621V47.8671L50.8592 48.5651Z",
    fill: "#EAE6E5",
    fillOpacity: 0.3725
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.2604L49.2637 49.6621V47.8671L50.8592 48.5651Z",
    fill: "#EBE7E6",
    fillOpacity: 0.3529
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.2604L49.2637 49.5624V47.8671L50.8592 48.5651Z",
    fill: "#ECE9E7",
    fillOpacity: 0.3333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.1607L49.2637 49.4626V47.8671L50.8592 48.5651Z",
    fill: "#EDEAE9",
    fillOpacity: 0.3137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.1607L49.2637 49.4626V47.8671L50.8592 48.5651Z",
    fill: "#EFEBEA",
    fillOpacity: 0.2941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V50.061L49.2637 49.3629V47.8671L50.8592 48.5651Z",
    fill: "#F0EDEC",
    fillOpacity: 0.2745
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.9613L49.2637 49.3629V47.8671L50.8592 48.5651Z",
    fill: "#F1EEED",
    fillOpacity: 0.2549
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.9613L49.2637 49.2632V47.8671L50.8592 48.5651Z",
    fill: "#F2EFEE",
    fillOpacity: 0.2353
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.8615L49.2637 49.1635V47.8671L50.8592 48.5651Z",
    fill: "#F3F1F0",
    fillOpacity: 0.2157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.8615L49.2637 49.1635V47.8671L50.8592 48.5651Z",
    fill: "#F4F2F1",
    fillOpacity: 0.1961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.7618L49.2637 49.0637V47.8671L50.8592 48.5651Z",
    fill: "#F5F3F2",
    fillOpacity: 0.1765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.6621L49.2637 49.0637V47.8671L50.8592 48.5651Z",
    fill: "#F6F4F4",
    fillOpacity: 0.1569
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.6621L49.2637 48.964V47.8671L50.8592 48.5651Z",
    fill: "#F7F6F5",
    fillOpacity: 0.1373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.5624L49.2637 48.8643V47.8671L50.8592 48.5651Z",
    fill: "#F8F7F7",
    fillOpacity: 0.1176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.5624L49.2637 48.8643V47.8671L50.8592 48.5651Z",
    fill: "#FAF8F8",
    fillOpacity: 0.0980392
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.4626L49.2637 48.7646V47.8671L50.8592 48.5651Z",
    fill: "#FBFAF9",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.3629L49.2637 48.7646V47.8671L50.8592 48.5651Z",
    fill: "#FCFBFB",
    fillOpacity: 0.0588235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.3629L49.2637 48.6648V47.8671L50.8592 48.5651Z",
    fill: "#FDFCFC",
    fillOpacity: 0.0392157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.2632L49.2637 48.5651V47.8671L50.8592 48.5651Z",
    fill: "#FEFEFE",
    fillOpacity: 0.0196078
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8592 48.5651V49.2632L49.2637 48.5651V47.8671L50.8592 48.5651Z",
    fill: "white",
    fillOpacity: 0.01
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L50.8588 52.2547L49.2632 51.6564L45.374 53.4514L46.5707 54.3489Z",
    fill: "#CDBFBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L50.7591 52.2547L49.1635 51.6564L45.374 53.4514L46.5707 54.3489Z",
    fill: "#CEC0BD",
    fillOpacity: 0.9804
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L50.6593 52.3544L49.1635 51.6564L45.374 53.4514L46.5707 54.3489Z",
    fill: "#CFC2BF",
    fillOpacity: 0.9608
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L50.6593 52.3544L49.0638 51.6564L45.374 53.4514L46.5707 54.3489Z",
    fill: "#D0C3C0",
    fillOpacity: 0.9412
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L50.5596 52.3544L48.9641 51.7561L45.374 53.4514L46.5707 54.3489Z",
    fill: "#D1C4C1",
    fillOpacity: 0.9216
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L50.4599 52.4542L48.9641 51.7561L45.374 53.4514L46.5707 54.3489Z",
    fill: "#D2C5C3",
    fillOpacity: 0.902
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L50.4599 52.4542L48.8643 51.7561L45.374 53.4514L46.5707 54.3489Z",
    fill: "#D3C7C4",
    fillOpacity: 0.8824
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.349L50.3602 52.4543L48.8643 51.856L45.374 53.4515L46.5707 54.349Z",
    fill: "#D4C8C5",
    fillOpacity: 0.8627
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.349L50.2605 52.554L48.7646 51.856L45.374 53.4515L46.5707 54.349Z",
    fill: "#D5C9C7",
    fillOpacity: 0.8431
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.349L50.2605 52.554L48.6649 51.856L45.374 53.4515L46.5707 54.349Z",
    fill: "#D6CAC8",
    fillOpacity: 0.8235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.349L50.1607 52.554L48.6649 51.856L45.374 53.4515L46.5707 54.349Z",
    fill: "#D7CCC9",
    fillOpacity: 0.8039
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L50.061 52.6534L48.5652 51.9553L45.374 53.4512L46.5707 54.3487Z",
    fill: "#D8CDCA",
    fillOpacity: 0.7843
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L50.061 52.6534L48.5652 51.9553L45.374 53.4512L46.5707 54.3487Z",
    fill: "#D9CECC",
    fillOpacity: 0.7647
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L49.9613 52.6534L48.4654 51.9553L45.374 53.4512L46.5707 54.3487Z",
    fill: "#DACFCD",
    fillOpacity: 0.7451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L49.9613 52.7531L48.3657 52.0551L45.374 53.4512L46.5707 54.3487Z",
    fill: "#DBD1CE",
    fillOpacity: 0.7255
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L49.8616 52.7531L48.3657 52.0551L45.374 53.4512L46.5707 54.3487Z",
    fill: "#DCD2D0",
    fillOpacity: 0.7059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L49.7618 52.7531L48.266 52.0551L45.374 53.4512L46.5707 54.3487Z",
    fill: "#DDD3D1",
    fillOpacity: 0.6863
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L49.7618 52.8528L48.266 52.0551L45.374 53.4512L46.5707 54.3487Z",
    fill: "#DED4D2",
    fillOpacity: 0.6667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3488L49.6621 52.853L48.1663 52.1549L45.374 53.4513L46.5707 54.3488Z",
    fill: "#DFD6D4",
    fillOpacity: 0.6471
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3488L49.5624 52.853L48.0665 52.1549L45.374 53.4513L46.5707 54.3488Z",
    fill: "#E0D7D5",
    fillOpacity: 0.6275
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3488L49.5624 52.9527L48.0665 52.1549L45.374 53.4513L46.5707 54.3488Z",
    fill: "#E1D8D6",
    fillOpacity: 0.6078
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L49.4627 52.9528L47.9668 52.2548L45.374 53.4514L46.5707 54.3489Z",
    fill: "#E2D9D8",
    fillOpacity: 0.5882
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L49.3629 52.9528L47.9668 52.2548L45.374 53.4514L46.5707 54.3489Z",
    fill: "#E3DBD9",
    fillOpacity: 0.5686
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L49.3629 53.0525L47.8671 52.2548L45.374 53.4514L46.5707 54.3489Z",
    fill: "#E4DCDA",
    fillOpacity: 0.549
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L49.2632 53.0525L47.7674 52.2548L45.374 53.4514L46.5707 54.3489Z",
    fill: "#E5DDDC",
    fillOpacity: 0.5294
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.349L49.1635 53.0526L47.7674 52.3545L45.374 53.4514L46.5707 54.349Z",
    fill: "#E6DEDD",
    fillOpacity: 0.5098
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.349L49.1635 53.1523L47.6677 52.3545L45.374 53.4514L46.5707 54.349Z",
    fill: "#E6E0DE",
    fillOpacity: 0.4902
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.349L49.0638 53.1523L47.6677 52.3545L45.374 53.4514L46.5707 54.349Z",
    fill: "#E7E1DF",
    fillOpacity: 0.4706
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3486L48.9641 53.1519L47.5679 52.4539L45.374 53.4511L46.5707 54.3486Z",
    fill: "#E8E2E1",
    fillOpacity: 0.451
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3486L48.9641 53.2516L47.4682 52.4539L45.374 53.4511L46.5707 54.3486Z",
    fill: "#E9E3E2",
    fillOpacity: 0.4314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3486L48.8643 53.2516L47.4682 52.4539L45.374 53.4511L46.5707 54.3486Z",
    fill: "#EAE5E3",
    fillOpacity: 0.4118
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L48.7646 53.2518L47.3685 52.5537L45.374 53.4512L46.5707 54.3487Z",
    fill: "#EBE6E5",
    fillOpacity: 0.3922
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L48.7646 53.3515L47.3685 52.5537L45.374 53.4512L46.5707 54.3487Z",
    fill: "#ECE7E6",
    fillOpacity: 0.3725
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L48.6649 53.3515L47.2688 52.5537L45.374 53.4512L46.5707 54.3487Z",
    fill: "#EDE8E7",
    fillOpacity: 0.3529
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3487L48.5652 53.3515L47.169 52.5537L45.374 53.4512L46.5707 54.3487Z",
    fill: "#EEEAE9",
    fillOpacity: 0.3333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L48.5652 53.4513L47.169 52.6536L45.374 53.4513L46.5707 54.3489Z",
    fill: "#EFEBEA",
    fillOpacity: 0.3137
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L48.4654 53.4513L47.0693 52.6536L45.374 53.4513L46.5707 54.3489Z",
    fill: "#F0ECEB",
    fillOpacity: 0.2941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L48.3657 53.4513L47.0693 52.6536L45.374 53.4513L46.5707 54.3489Z",
    fill: "#F1EDED",
    fillOpacity: 0.2745
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L48.3657 53.5511L46.9696 52.7533L45.374 53.4514L46.5707 54.3489Z",
    fill: "#F2EFEE",
    fillOpacity: 0.2549
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L48.266 53.5511L46.8699 52.7533L45.374 53.4514L46.5707 54.3489Z",
    fill: "#F3F0EF",
    fillOpacity: 0.2353
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L48.266 53.5511L46.8699 52.7533L45.374 53.4514L46.5707 54.3489Z",
    fill: "#F4F1F1",
    fillOpacity: 0.2157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3489L48.1663 53.5511L46.7701 52.7533L45.374 53.4514L46.5707 54.3489Z",
    fill: "#F5F2F2",
    fillOpacity: 0.1961
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.349L48.0665 53.6509L46.7701 52.8531L45.374 53.4515L46.5707 54.349Z",
    fill: "#F6F4F3",
    fillOpacity: 0.1765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.349L48.0665 53.6509L46.6704 52.8531L45.374 53.4515L46.5707 54.349Z",
    fill: "#F7F5F4",
    fillOpacity: 0.1569
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.349L47.9668 53.6509L46.5707 52.8531L45.374 53.4515L46.5707 54.349Z",
    fill: "#F8F6F6",
    fillOpacity: 0.1373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3486L47.8671 53.7503L46.5707 52.9525L45.374 53.4511L46.5707 54.3486Z",
    fill: "#F9F7F7",
    fillOpacity: 0.1176
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3486L47.8671 53.7503L46.471 52.9525L45.374 53.4511L46.5707 54.3486Z",
    fill: "#FAF9F8",
    fillOpacity: 0.0980392
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3486L47.7674 53.7503L46.471 52.9525L45.374 53.4511L46.5707 54.3486Z",
    fill: "#FBFAFA",
    fillOpacity: 0.0784314
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3486L47.6677 53.85L46.3713 52.9525L45.374 53.4511L46.5707 54.3486Z",
    fill: "#FCFBFB",
    fillOpacity: 0.0588235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3488L47.6677 53.8502L46.2715 53.0524L45.374 53.4513L46.5707 54.3488Z",
    fill: "#FDFCFC",
    fillOpacity: 0.0392157
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3488L47.5679 53.8502L46.2715 53.0524L45.374 53.4513L46.5707 54.3488Z",
    fill: "#FEFEFE",
    fillOpacity: 0.0196078
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5707 54.3488L47.4682 53.9499L46.1718 53.0524L45.374 53.4513L46.5707 54.3488Z",
    fill: "white",
    fillOpacity: 0.01
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1667 62.3269L57.6404 57.5402L55.247 56.3435L45.873 61.1302L48.1667 62.3269Z",
    fill: "#CCCCCC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M45.873 61.1304L55.247 56.3437V54.5487L45.873 59.3354V61.1304Z",
    fill: "#999999"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48.166 64.3216L57.6397 59.5349V57.5404L48.166 62.3271V64.3216Z",
    fill: "#999999"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8584 52.2548L55.2463 54.5484L45.8723 59.3351L41.3848 56.9417L50.8584 52.2548Z",
    fill: "#CCCCCC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3848 60.7314L48.1659 64.3214V62.3269L45.8723 61.1303V59.3352L41.3848 56.9419V60.7314Z",
    fill: "#999999"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9086 25.7283L53.5512 20.8419L17.1523 2.79199L34.6039 8.77537L68.9086 25.7283Z",
    fill: "#A7666A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0.998047 23.6341L35.203 40.6867L53.5521 20.8419L17.1532 2.79199L0.998047 23.6341Z",
    fill: "#914045"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M35.203 41.7841V40.6872L0.998047 23.6345V24.4323L35.203 41.7841Z",
    fill: "#9A3F54"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2021 41.7839V40.6869L53.5512 20.842L68.9085 25.7285V26.4265L53.8503 21.6398L35.2021 41.7839Z",
    fill: "#914045"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1362 7.47924L20.1445 5.9834V10.4709L23.1362 11.9668V7.47924Z",
    fill: "#FCD485"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0547 14.8587L20.1433 10.4709V5.9834L16.0547 8.07758V14.8587Z",
    fill: "#FCD485"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0547 8.07734L20.1433 5.98315L23.135 7.479L19.0464 9.57318L16.0547 8.07734ZM22.038 7.4791L20.1433 6.58159L17.1516 8.07743L19.0463 8.97494L22.038 7.4791Z",
    fill: "#FFF7F0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0464 16.3546L16.0547 14.8588V8.07764L19.0464 9.57348V16.3546Z",
    fill: "#FDE5B6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0469 16.3546L23.1355 11.9668V7.47925L19.0469 9.57343V16.3546Z",
    fill: "#FDE5B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationHouse);
export default __webpack_public_path__ + "static/media/illustration-house.f70574cfccf45e898baba5ae45a39039.svg";
export { ForwardRef as ReactComponent };